var $vehicleVisualizationModal;

(function() {
	$vehicleVisualizationModal = {
		getVehicleImage: getVehicleImage,
		show: show
	}

	function getVehicleImage(vehicleID, fitmentID, paintColor, suspension, rotation){
	   var vehicleImage = ridestyler.ajax.url('vehicle/render', {
        vehicleconfiguration: vehicleID,
        wheelfitment: fitmentID,
        positionx: 1,
        positiony: 1,
        type: rotation,
        width: 1000,
        height: 375,
        paintColor: paintColor,
		suspensionRear: suspension.rear,
		suspensionFront: suspension.front
    });
	   return vehicleImage;
	};

	function show(vehicleID, fitmentID, paintColor, suspension, rotation){
		var $modal = modal.createModalLoader();
		
		$modal.$modalDialog.addClass('modal-xl');
		$modal.$modalContent.addClass('p-5');
		var vehicleImageSrc = this.getVehicleImage(vehicleID, fitmentID, paintColor, suspension, rotation);
		var $vehicleImage = $('<img/>', {"src": vehicleImageSrc, "class": "img-fluid"});

		$modal.appendTo(document.body).modal();
		$vehicleImage.appendTo($modal.$modalContent);
		$modal.$modalContent.removeClass('loading');

		$modal.on('hidden.bs.modal', function (e) {
        $modal.modal('dispose').remove();
    });
	}
})();